import { render, staticRenderFns } from "./CRMTableHead.vue?vue&type=template&id=829c82ae&scoped=true&"
import script from "./CRMTableHead.vue?vue&type=script&lang=js&"
export * from "./CRMTableHead.vue?vue&type=script&lang=js&"
import style0 from "./CRMTableHead.vue?vue&type=style&index=0&id=829c82ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829c82ae",
  null
  
)

export default component.exports